function sendAnalytics(analyticTrackingId, { currentUser, ...analyticProps }) {
  const user = currentUser && (currentUser.data || currentUser);

  try {
    if (user?.attributes.email?.includes('@handshq.com')) return null;

    analytics.track(
      analyticTrackingId,
      user ?
        {
          email: user.attributes.email,
          userId: user.id,
          ...analyticProps,
        }
      : analyticProps,
    );
  } catch (error) {
    console.error(error);
  }
}

export { sendAnalytics };
